export const excludedRoles = ['Accounting Partner', 'Payroll Partner'];
